<template>

  <div
  v-bind:style="{
    'font-size': infoFontSize
  }"
  ontouchstart=""
  class="comp-psap-event-video">

    <div class="info-container">
    
      <div class="info-items scrollable -x scrollbar-hidden">
        <div class="info-item black">EVENT VIDEO</div>
        <div
        v-if="eventLocaleTimeString"
        class="info-item black">{{eventLocaleTimeString}}{{friendlyEventTimeString ? ' (' + friendlyEventTimeString + ' ago)' : ''}}</div>
      </div>

    </div>

    <CompMediaPlaceholder/>

    <div class="video-media-wrapper">
      <video
      v-if="videoUrl"
      muted loop controls
      playsinline webkit-playsinline
      v-bind:autoplay="autoPlay"
      v-on:error="videoError"
      style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:fill;">
        <source v-bind:src="videoUrl" type="video/mp4">
        Your browser does not support the video tag.
      </video>
      <div v-if="isVideoErr"
        class="err-box">
        <div class="err-txt">
          <div>{{errMsg}}</div>
          <div>{{errSubMsg}}</div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import CompMediaPlaceholder from '@/components/CompMediaPlaceholder'
export default {
  name: 'comp-psap-event-video',
  components: {
    CompMediaPlaceholder
  },
  props: {
    infoFontSize: {
      type: String,
      default: function () {
        return '16px'
      }
    },
    autoPlay: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    isControllable: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  computed: {
    psapSite: function () {
      return this.$store.getters.psapSite
    },
    psapEvent: function () {
      return this.$store.getters.psapEvent
    },
    psapEventMedias: function () {
      return this.$store.getters.psapEventMedias
    },
    psapEventRecords: function () {
      return this.$store.getters.psapEventRecords
    },
    statusGetPsapEvent: function () {
      return this.$store.getters.statusGetPsapEvent
    },
    statusGetPsapEventMedias: function () {
      return this.$store.getters.statusGetPsapEventMedias
    },
    statusGetPsapEventRecord: function () {
      return this.$store.getters.statusGetPsapEventRecord
    }
  },
  data: function () {
    return {
      loadingEventMedias$i: null,
      eventLocaleTimeString: null,
      friendlyEventTimeString: null,
      deviceName: null,
      deviceId: null,
      recordId: null,
      eventZone: null,
      eventType: null,
      eventStatus: null,
      videoUrl: null,
      isVideoErr: false,
      errMsg: '',
      errSubMsg: ''
    }
  },
  watch: {
    psapSite: function () {
      this.updateEventRelatedInfo()
    }
  },
  created: function () {
    this.init()
  },
  beforeDestroy: function () {
    this.stopLoadingEventMedias()
  },
  methods: {
    init: function () {
      this.videoUrl = null
      this.updateEventRelatedInfo()
      this.startLoadingEventMedias()
    },
    updateEventRelatedInfo: function () {
      if (!(this.psapEvent instanceof Object)) return
      if (this.psapSite.timezone) {
        let timezoneOffset = this.$tool.getUtcOffset((this.psapSite.timezone))
        let eventLocalTimestamp = this.$tool.getLocalTimestamp(this.psapEvent.eventTimestamp * 1000, timezoneOffset)
        this.eventLocaleTimeString = new Date(eventLocalTimestamp).toLocaleTimeString()
      }
      this.friendlyEventTimeString = this.$tool.getTimeDiffFromNow(+this.psapEvent.eventTimestamp * 1000).textDetail
    },
    // ////////////////////////////////////////
    // EVENT MEDIA
    // ////////////////////////////////////////
    startLoadingEventMedias: function () {
      this.downloadEventVideo()
      this.loadingEventMedias$i = setInterval(() => {
        this.downloadEventVideo()
      }, 1000 * 0.5)
    },
    stopLoadingEventMedias: function () {
      if (!this.loadingEventMedias$i) return
      clearInterval(this.loadingEventMedias$i)
      this.loadingEventMedias$i = null
    },
    // ////////////////////////////////////////
    // DOWNLOAD - Event medias
    // ////////////////////////////////////////
    downloadEventVideo: function () {
      // CHECK 1
      if (!this.psapEventMedias) return

      // GET recordInfo
      let recordInfo = null
      let mediaIndex = -1
      for (let index = 0; index < this.psapEventMedias.length; index++) {
        if (this.psapEventMedias[index].format !== 'mp4') continue
        mediaIndex = index
        recordInfo = this.psapEventMedias[index]
        break
      }

      // CHECK 2
      if (recordInfo === null) return
      if (mediaIndex < 0) return

      // INIT
      let recordId = recordInfo.recordId
      let downloadUrl = recordInfo.url

      // CASE 1. video is already downloaded
      if (this.psapEventRecords(recordId)) {
        this.videoUrl = this.psapEventRecords(recordId)
        return
      }

      // CASE 2. video download is already requested or successful
      if (this.statusGetPsapEventRecord(recordId) === 'requested') return
      if (this.statusGetPsapEventRecord(recordId) === 'successful') return

      // CASE 3. media download hasn't been requested yet or has been requested but failed
      this.downloadEventMedia(mediaIndex, recordId, downloadUrl)
    },
    // ////////////////////////////////////////
    // APIs
    // ////////////////////////////////////////
    downloadEventMedia: function (videoIndex, recordId, videoUrl) {
      this.$logger.info('downloadEventVideo: requested: recordId({recordId})'
        .replace('{recordId}', recordId))
      this.$store.dispatch('getPsapEventRecord', {
        snapshotIndex: videoIndex,
        recordId: recordId,
        url: videoUrl
      })
    },
    videoError: function (err, msg, subMsg) {
      this.errMsg = 'This Video has error'
      if (err) {
        if (err.srcElement) {
          if (err.srcElement.err) {
            this.errMsg = err.srcElement.err.message
          }
        }
      }
      if (msg) {
        this.errMsg = msg
      }
      if (subMsg) {
        this.errSubMsg = subMsg
      }
      this.isVideoErr = true
      this.$emit('onVideoErr', true)
    }
  }
}
</script>

<style scoped>
.comp-psap-event-video {
  /* common */
  background-color: #fff;
  color: #333;
  font-size: 14px;
  outline: 1px solid #fff;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}


.comp-psap-event-video .info-container {
  /* common */
  background-color: #000;
  color: #fff;
  font-size: 0.8em;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.comp-psap-event-video .info-container .info-items {
  /* size */
  padding: 0.5em 0.5em 0.5em 0.5em;
  width: calc(100% - 1em);
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.comp-psap-event-video .info-container .info-items .info-item {
  /* common */
  background-color: hsla(202, 100%, 80%, 1);
  color: hsla(193, 100%, 0%, 0.7);
  border-radius: 1px;
  cursor: pointer;
  font-weight: bold;
  white-space: nowrap;
  /* size */
  padding: 2px 0.5em;
  /* position */
  position: relative;
  margin-right: 0.2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.comp-psap-event-video .info-container .info-items .info-item:last-child {
  /* position */
  margin-right: 0;
}
.comp-psap-event-video .info-container .info-items .info-item.black {
  /* common */
  color: #fff;
  background-color: #000;
}
.comp-psap-event-video .info-container .info-items .info-item.info {
  /* common */
  color: #fff;
  background-color: hsla(202, 100%, 50%, 1);
}
.comp-psap-event-video .info-container .info-items .info-item.error {
  /* common */
  color: #fff;
  background-color: hsla(0, 100%, 60%, 1);
}
.comp-psap-event-video .info-container .info-items .info-item.inactive {
  /* common */
  background-color: hsla(202, 0%, 30%, 0.1);
  color: #fff;
}

.comp-psap-event-video .video-media-wrapper .err-box {
  position: absolute;
  display:flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  top: 0;
  height: 100%;
  width: 100%;
}

.comp-psap-event-video .video-media-wrapper .err-box .err-txt {
  width: 95%;
  color: hsla(0,0%,87%,1);
  font-size: 3rem;
}



.comp-psap-event-video .video-media-wrapper {
  /* size */
  width: 100%;
  padding-top: calc(100% / 16 * 9);
  /* position */
  position: absolute;
  bottom: 0;
  left: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/CompPsapEventVideo.vue